import { render, staticRenderFns } from "./forms-view-categories.vue?vue&type=template&id=32a65084"
import script from "./forms-view-categories.vue?vue&type=script&lang=js"
export * from "./forms-view-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports